const SvgOrangeDocumentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#F69133"
      d="M25.666 11.667V17.5c0 5.833-2.333 8.167-8.166 8.167h-7c-5.834 0-8.167-2.334-8.167-8.167v-7c0-5.833 2.333-8.167 8.167-8.167h5.833"
    />
    <path
      stroke="#F79133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M25.666 11.667V17.5c0 5.833-2.333 8.167-8.166 8.167h-7c-5.834 0-8.167-2.334-8.167-8.167v-7c0-5.833 2.333-8.167 8.167-8.167h5.833"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M25.666 11.667H21c-3.5 0-4.667-1.167-4.667-4.667V2.333zM8.167 15.167h7M8.167 19.833h4.667"
    />
  </svg>
);
export default SvgOrangeDocumentIcon;
